import { Box, TableCell, TableRow } from "@mui/material";

const ShimmerTableRow = ({ columnCount = 7 }) => {
    return (
        <TableRow className="shimmer-row" data-testid="shimmer-row">
            <TableCell sx={{ width: '60px' }}>
                <Box className="shimmer-content" sx={{ width: 24, height: 24, borderRadius: '4px' }} />
            </TableCell>
            {Array.from({ length: columnCount - 1 }).map((_, index) => (
                <TableCell key={index} sx={{ width: '200px' }}>
                    <Box className="shimmer-content" sx={{ width: '100%' }} />
                </TableCell>
            ))}
        </TableRow>
    );
};

export default ShimmerTableRow;
